import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import { Alert } from 'reactstrap';
import __ from 'utils/i18n';

export const CancelSubscriptionModal = ({ 
  showModal = false, 
  hideModal, 
  subscriber, 
  submitAction, 
  submitDisabled = false 
}) => {
  if (!subscriber) return null;

  const customerName = subscriber.customer?.fullName || __('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.defaultCustomer');
  const planName = subscriber.plan?.name || '-';

  return (
    <DashboardModal
      name="cancelSubscriptionModal"
      headerText={__('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.title')}
      showModal={showModal}
      hideModal={hideModal}
      submitAction={submitAction}
      submitColor="danger"
      submitDisabled={submitDisabled}
      hideSeparator={true}
      cancelText={__('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.cancelButton')}
      submitText={submitDisabled 
        ? __('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.canceling')
        : __('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.confirmButton')
      }
    >
      <div className="recurring-payments-text-wrap">
        <p className="mb-3">
          {__('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.description', { 
            customerName, 
            planName,
            interpolation: { escapeValue: false }
          })}
        </p>
        
        <Alert color="warning" className="d-flex align-items-start mb-0">
          <i className="mdi mdi-alert mr-2 mt-1" style={{ fontSize: '20px' }}></i>
          <span>
            {__('dashboard.sections.recurringPayments.subscribers.cancelSubscriptionModal.warning')}
          </span>
        </Alert>
      </div>
    </DashboardModal>
  );
};

